import React, { createElement, Component } from 'react';
import { Helmet } from 'react-helmet';
import { HeroSection } from './components/HeroSection';
import { HabitsSection } from './components/HabitsSection';
import { DiscoverySection } from './components/DiscoverySection';
import { CTASection } from './components/CTASection';
import { SocialProofSection } from './components/SocialProofSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-amber-50 font-sans" data-id="element-0">
      <Helmet data-id="element-1">
        {/* ================= TABOOLA PIXEL ================= */}
        <script type="text/javascript" data-id="element-2">
          {`
            window._tfa = window._tfa || [];
            _tfa.push({notify: 'event', name: 'page_view', id: 1902567});
            !function (t, f, a, x) {
              if (!document.getElementById(x)) {
                t.async = 1; t.src = a; t.id = x; f.parentNode.insertBefore(t, f);
              }
            }(document.createElement('script'),
            document.getElementsByTagName('script')[0],
            '//cdn.taboola.com/libtrc/unip/1902567/tfa.js',
            'tb_tfa_script');
          `}
        </script>
        {/* ================= NEWSBREAK PIXEL ================= */}
        <script data-id="element-3">
          {`
            !(function(e,n,t,i,p,a,s){   
              e[i]=e[i]||function(){ 
                (e[i].process ? e[i].process.apply(e[i],arguments) : e[i].queue.push(arguments)); 
              };   
              e[i].queue=[]; 
              p=+new Date();   
              (a=n.createElement(t)).async=1;   
              a.src='https://static.newsbreak.com/business/tracking/nbpixel.js?t=' + 864e5*Math.ceil(new Date()/864e5);   
              (s=n.getElementsByTagName(t)[0]).parentNode.insertBefore(a,s); 
            })(window,document,'script','nbpix');  
            // Your account ID: 
            nbpix('init','1962358158714441729'); 
            // Fire page load: 
            nbpix('event','pageLoad');
          `}
        </script>
        <meta httpEquiv="delegate-ch" content="sec-ch-ua https://track.marthaslife.blog; sec-ch-ua-mobile https://track.marthaslife.blog; sec-ch-ua-arch https://track.marthaslife.blog; sec-ch-ua-model https://track.marthaslife.blog; sec-ch-ua-platform https://track.marthaslife.blog; sec-ch-ua-platform-version https://track.marthaslife.blog; sec-ch-ua-bitness https://track.marthaslife.blog; sec-ch-ua-full-version-list https://track.marthaslife.blog; sec-ch-ua-full-version https://track.marthaslife.blog" data-id="element-4" />
        <style data-id="element-5">{`.dtpcnt{opacity: 0;}`}</style>
        <script data-id="element-6">
          {`
            (function(d,c,k,l,r,t,g,u,A,e,m,v,B,a,n,p,h,q,w,D,x){function y(){for(var f=c.querySelectorAll(".dtpcnt"),b=0,a=f.length;b<a;b++)f[b][u]=f[b][u].replace(/(^|\\s+)dtpcnt($|\\s+)/g,"")}function C(a,b,d,e){var f=new Date;f.setTime(f.getTime()+(e||864E5));c.cookie=a+"="+b+"; "+d+"samesite=Strict; expires="+f.toGMTString()+"; path=/";k.setItem(a,b);k.setItem(a+"-expires",f.getTime())}function z(a){var b=c.cookie.match(new RegExp("(^| )"+a+"=([^;]+)"));return b?b.pop():k.getItem(a+"-expires")&&+k.getItem(a+"-expires")>(new Date).getTime()?k.getItem(a):null}x="https:"===d.location.protocol?"secure; ":"";d[e]||(d[e]=function(){(d[e].q=d[e].q||[]).push(arguments)},p=c[r],c[r]=function(){p&&p.apply(this,arguments);if(d[e]&&!d[e].hasOwnProperty("params")&&/loaded|interactive|complete/.test(c.readyState))for(;a=c[t][m++];)/\\/?click\\/?($|(\\/[0-9]+)?$)/.test(a.pathname)&&(a[g]="javascrip"+d.postMessage.toString().slice(4,5)+":"+e+'.l="'+a[g]+'",void 0')},setTimeout(function(){(q=/[?&]cpid(=([^&#]*)|&|#|$)/.exec(d.location.href))&&
q[2]&&(h=q[2],w=z("vl-"+h));var f=z("vl-cep"),b=location[g];if("savedCep"===B&&f&&(!h||"undefined"===typeof h)&&0>b.indexOf("cep=")){var e=-1<b.indexOf("?")?"&":"?";b+=e+f}a=c.createElement("script");n=c.scripts[0];a.defer=1;a.src=v+(-1===v.indexOf("?")?"?":"&")+"lpref="+l(c.referrer)+"&lpurl="+l(b)+"&lpt="+l(c.title)+"&vtm="+(new Date).getTime()+(w?"&uw=no":"");a[A]=function(){for(m=0;a=c[t][m++];)/dtpCallback\\.l/.test(a[g])&&(a[g]=decodeURIComponent(a[g]).match(/dtpCallback\\.l="([^"]+)/)[1]);y()};
n.parentNode.insertBefore(a,n);h&&C("vl-"+h,"1",x)},0),setTimeout(y,7E3))})(window,document,localStorage,encodeURIComponent,"onreadystatechange","links","href","className","onerror","dtpCallback",0,"https://track.marthaslife.blog/d/dfd06a89-4cad-4d25-bbe8-6eca9c6ff9ba.js","savedCep");
          `}
        </script>
        <noscript data-id="element-7">
          {`<link href="https://track.marthaslife.blog/d/dfd06a89-4cad-4d25-bbe8-6eca9c6ff9ba.js?noscript=true&lpurl=" rel="stylesheet"/>`}
        </noscript>
      </Helmet>
      <div className="text-center py-0.5 bg-amber-50 text-gray-500 text-xs" data-id="element-8">
        advertorial
      </div>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6" data-id="element-9">
        <HeroSection data-id="element-10" />
        <HabitsSection data-id="element-11" />
        <DiscoverySection data-id="element-12" />
        <CTASection data-id="element-13" />
        <SocialProofSection data-id="element-14" />
        <Footer data-id="element-15" />
      </main>
    </div>;
}